import { Component, OnInit,Input } from '@angular/core';
import {FacilityService} from '../../../shared/services/facility.service';
import {UtilsService} from '../../../shared/services/utils.service';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-change-category-history',
  templateUrl: './change-category-history.component.html',
  styleUrls: ['./change-category-history.component.css']
})

export class ChangeCategoryHistoryComponent implements OnInit {

  @Input('facilityID') id: number;
  @Input() modalRef: BsModalRef;

  public catHistoryLog;

  constructor(private facilityService: FacilityService, private utilService: UtilsService) { }

  ngOnInit() {

    this.getCategoryHistory();
  }

  convertedDate(date){
    return this.utilService.getConvertedDateFormat(date);
  }

  calculateHowLongAgo(date){
    return this.utilService.timeAgoCalc(date);
  }
  
  getCategoryHistory(){
    this.facilityService.getFacilityCategoryHistory(this.id).subscribe(res=>{
      if(res){
        this.catHistoryLog = res;
      }
    })
  }

  colorTextByCategory(catColor:string){
    if(catColor){
      const color = catColor.toLowerCase();
      var classToUse;
      switch(color){
        case 'red':
          classToUse = 'text-danger';
          break;
        case 'yellow':
          classToUse = 'text-warning';
          break;
        case 'green':
          classToUse = 'text-success';
          break;
        default:
            classToUse = 'text-dark';
          break;
      }

      return classToUse;
    }
  }

  getDate(dateStr){
    return (new Date(dateStr)).toDateString();
  }

}
